// extracted by mini-css-extract-plugin
export var flybusWrapper = "flybus-module--flybusWrapper--1X99D";
export var highlightsContainer = "flybus-module--highlightsContainer--12yrx";
export var flybusContainer = "flybus-module--flybusContainer--27TIa";
export var transportContainer = "flybus-module--transportContainer--3-2t_";
export var productList = "flybus-module--productList--3iLiq";
export var seeMore = "flybus-module--seeMore--3EuhZ";